import React from 'react';
import MachineLabels from '../features/machineLabels';

export default function MachineLabelsPage () {
  return (
    <MachineLabels />
  );
}